import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[appTableIcon]',
})
export class TableIconDirective {
    public constructor(public readonly templateRef: TemplateRef<void>) {}
}
